/**
 * Backend errors arrive as `error.cause` = response body: `{ message }` for
 * upstream API failures (502), `{ detail }` for DRF errors such as a missing
 * flow (404), `{ message, details }` for validation errors (400).
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const cause = (error as { cause?: Record<string, unknown> } | null)?.cause;
  for (const key of ['details', 'detail', 'message'] as const) {
    const value = cause?.[key];
    if (typeof value === 'string' && value) return value;
  }
  const message = (error as { message?: unknown } | null)?.message;
  return typeof message === 'string' && message ? message : fallback;
};
